import React, { useEffect, useState, useContext } from 'react';
import { Link, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import Dropdown from 'react-bootstrap/Dropdown'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import PaymentsListModal from '../../modals/PaymentsListModal';
import { Accordion, AccordionTab } from 'primereact/accordion';
import StoreInfo from '../../parts/StoreInfo';
import { getApiData } from '../../../services/apiService';
import { serviceRequestData } from '../../../services/serviceHubStore';
import { TbChecklist, TbCalendar , TbEdit, TbTrash, TbFileTypePdf, TbCancel } from "react-icons/tb";
import { LiaFileSignatureSolid } from "react-icons/lia";
import { postApiData } from '../../../services/apiService';
import { FaRegFilePdf } from "react-icons/fa";
import ProfileContext from '../../../services/profileContext';

export default function ServiceRequestView ({view = 'all'}){
    const {
        account
    } = useContext(ProfileContext);

    const { service_request_id } = useParams();
    const [loading, setLoading] = useState(1);
    const [page_title, setPageTitle] = useState('New Invoice');
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(serviceRequestData);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [invoice_table, setInvoiceTable] = useState([]);
    
   
    useEffect(() => {
        initTreeView()
        if(service_request_id){
            setPageTitle('Service Request Details')
            fetchData()
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    useEffect(() => {

    }, [record_data]);

    async function fetchData(){
        if(!service_request_id){
            return
        }

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/${service_request_id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            setRecordLoaded(1)
            setLoading(0)
            setRecordData(res)
            setRecordItems(res.items)
        }
                
        if(res.status === 'error'){
            setRecordLoaded(1)
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/service-requests/list");
                }
            })
        }
    }

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>{data.qr_code}</td>
                    <td>{data.brand}</td>
                    <td>{data.serial_no}</td>
                    <td>{data.invoice_no}</td>
                    <td>{data.unit_location ? data.unit_location : '---'}</td>
                    <td>{data.complaint ? data.complaint : '---'}</td>
                    <td>{data.assessment ? data.assessment : '---'}</td>
                    <td>{data.recommendation ? data.recommendation : '---'}</td>
                </tr>)
            })
        }

        setTableItems(
            <tbody>{items}</tbody>
        )
    }

    function triggerAction(data, status, action = ''){
        if(status > 0){
            if(status === 10){
                Swal.fire({
                    title: 'Cancel Service Request',
                    text: 'This action cannot be reversed. Do you want to continue?',
                    showCancelButton: true,
                    showConfirmButton: false,
                    closeOnCancel: true,
                    showDenyButton: true,
                    denyButtonText: 'Yes'
                })
                .then((result) => {
                    if (result.isDenied) {
                        updateStatusItem(data, status)
                    }
                })
                return
            }

            updateStatusItem(data, status)
        }
    }

    async function updateStatusItem(id, status){
        let form_data = {
            service_id: id,
            status: status
        }

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/update-status`)
        const res = await postApiData(endpoint, form_data)
        
        setLoading(0)
        if(res.status === 'error'){
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            return
        }
        
        Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false
        })
        .then((result) => {
            if (result.isConfirmed) {;
                fetchData(service_request_id)
            }
        })
    }

    function DisplayActionMenu(){                        
        const userPermissions = account?.permissions ?? ['superAdmin'];
        const isAuthorized = helpers.checkPermissions(['superAdmin','serviceHubView', 'serviceHubEdit', 'serviceHubDelete', 'serviceHubSchedule', 'serviceHubAssess','serviceHubAccept'], userPermissions);

        if(!isAuthorized) return;

        return (<Dropdown as={ButtonGroup} drop="down" className='mr-2' >
                    <Dropdown.Toggle variant="outline-primary" id="dropdown-split-basic">Action</Dropdown.Toggle>
                    <Dropdown.Menu>
                        {  
                            parseInt(record_data.status) === 4 ? 
                            <Dropdown.Item key="in-progress" onClick={(e) => triggerAction(record_data.id , 5, 'in-progress')}><i className="fas fa-check-circle mr-2" style={{width: '20px'}} />Start Service</Dropdown.Item> : ''
                        }
                        {  
                            parseInt(record_data.status) === 5 ? 
                            <Dropdown.Item key="complete" onClick={(e) => triggerAction(record_data.id, 6, 'service')}><i className="fas fa-check-circle mr-2 text-success" style={{width: '20px'}} />Ready for Acceptance</Dropdown.Item> : ''
                        }
                        {  
                            (parseInt(record_data.status) === 2 || parseInt(record_data.status) === 3) && view !== 'assigned' ? 
                            <Dropdown.Item key="schedule" as={Link}  to={`/service-requests/${record_data.id}/schedule`}><TbCalendar  size={20} className='mr-2'/>Service Schedule</Dropdown.Item> : ''
                        }
                        {  
                            parseInt(record_data.status) === 3 || parseInt(record_data.status) === 4 ? 
                            <Dropdown.Item key="assessment" as={Link}  to={`/service-requests/${record_data.id}/assessment`}><TbChecklist size={20} className='mr-2'/>Assessment
                            </Dropdown.Item> : ''
                        }
                        {  
                            parseInt(record_data.status) === 3 || parseInt(record_data.status) === 4 || parseInt(record_data.status) === 5 || parseInt(record_data.status) === 6 || parseInt(record_data.status) === 7 ? 
                            <Dropdown.Item key="acceptance" as={Link}  to={`/service-requests/${record_data.id}/acceptance`}><LiaFileSignatureSolid size={20} className='mr-2'/>Acceptance
                            </Dropdown.Item> : ''
                        }
                        
                        {
                            view !== 'assigned' ?
                            <Dropdown.Item key="job-order" as={Link}  to={`/service-requests/${record_data.id}/print`} target='new'><TbFileTypePdf size={20} className='mr-2'/>Print Job Order</Dropdown.Item> : ''
                        }
                        
                        {
                            parseInt(record_data.status) === 8 ?
                            <Dropdown.Item key="print-accetance" as={Link}  to={`/service-requests/${record_data.id}/print-acceptance`} target='new'><TbFileTypePdf size={20} className='mr-2'/>Print Acceptance Form</Dropdown.Item> : ''
                        }
        
                        {
                            parseInt(record_data.status) != 8 && parseInt(record_data.status) !== 9 && parseInt(record_data.status) !== 10 && view !== 'assigned' ?
                            <Dropdown.Item key="edit" as={Link}  to={`/service-requests/${record_data.id}/form`}><TbEdit size={20} className='mr-2' />Edit</Dropdown.Item> : ''
                        }

                        {
                            parseInt(record_data.status) != 8 && parseInt(record_data.status) !== 9 && parseInt(record_data.status) !== 10 && view !== 'assigned' ?
                            <Dropdown.Item key="in-progress" onClick={(e) => triggerAction(record_data.id, 10, 'cancel')}><TbCancel size={20} className='mr-2 text-danger' />Cancel Request</Dropdown.Item> : ''
                        }
                    </Dropdown.Menu>
                </Dropdown>
        )
    }

    return (
        <>
        <PaymentsListModal show_modal={payments_modal} id={service_request_id} close_modal={setPaymentsModal} />
        <Layout page_title={page_title} menu="manage-service-request" breadcrumbs={true} parent_link='/service-requests/list' parent_text="PolarCare">
                <div className="content" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div service_request_id="so-customer-section" className="col-lg-12">
                                    {record_loaded ?
                                    <div className='border rounded p-3 mb-3 d-flex justify-content-between align-items-center'>

                                        <h5 className='mb-0 mb-md-0 d-flex'>{record_data.service_no}</h5>

                                        <div>
                                            <DisplayActionMenu />
                                            {
                                                view === 'assigned' ?
                                                <Link className='btn btn-dark' to="/service-requests/schedule">Cancel</Link>  :
                                                <Link className='btn btn-dark' to="/service-requests/list">Cancel</Link>
                                            }
                                        </div>
                                    </div> : ''}
                                </div>
                            </div>
                    </div>
                            
                    <div className="container">
                        {
                            record_loaded ?
                            <div className="invoice p-4 mb-3 rounded">
                                <div className="d-flex justify-content-between mb-3">
                                    {/* <StoreInfo store={record_data.store_info} /> */}
                                    <div>
                                        <img src={images.main_logo} height={120} />
                                    </div>

                                    <div className='text-right'>
                                        <h4><strong>SERVICE REQUEST</strong></h4>
                                        <h5>{helpers.displayServiceRequestStatusBadge(record_data.status, record_data.status_name)}</h5>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-lg-4 mb-3">
                                        <div>
                                            <p className='mb-0'><b>Polar-Air Aircon</b></p>
                                            <p className='mb-0'>Matias Building, National Highway, Isulan, Sultan Kudarat 9805</p>
                                            <p className='mb-0'>0953-685-7478</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <h5 className='mb-0'><b>To:</b></h5>
                                        <div>
                                            <p className='mb-0'><b>{record_data.customer_name}</b></p>
                                            <p className='mb-0'>{helpers.concatenateText([record_data.address_1, record_data.address_2, record_data.city, record_data.province], ', ')}</p>
                                            <p className='mb-0'>{record_data.phone_no ? record_data.phone_no : '---'}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 text-lg-right mb-2">
                                        <table className='table table-borderless table-sm'>
                                            <tbody>
                                                <tr>
                                                    <td className='py-0'><b>Service No:</b></td>
                                                    <td className='py-0'>{record_data.service_no}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Date:</b></td>
                                                    <td className='py-0'>{helpers.formatDate(record_data.request_date)}</td>
                                                </tr>
                                                {
                                                    record_data?.schedule_date ?
                                                    <tr>
                                                        <td className='py-0'><b>Schedule&nbsp;Date:</b></td>
                                                        <td className='py-0'>{record_data.schedule_date ? record_data.schedule_date : '---'}</td>
                                                    </tr> : ''
                                                }
                                                {
                                                    record_data?.assessment_date ?
                                                    <tr>
                                                        <td className='py-0'><b>Assessment&nbsp;Date:</b></td>
                                                        <td className='py-0'>{record_data.assessment_date ? record_data.assessment_date : '---'}</td>
                                                    </tr> : ''
                                                }
                                                {
                                                    record_data?.received_date ?
                                                    <tr>
                                                        <td className='py-0'><b>Accepted&nbsp;Date:</b></td>
                                                        <td className='py-0'>{record_data.received_date ? record_data.received_date : '---'}</td>
                                                    </tr> : ''
                                                }
                                                <tr>
                                                    <td className='py-0'><b>Service Type:</b></td>
                                                    <td className='py-0'>{helpers.concatenateText([record_data?.service_type_name, record_data?.sub_service_type_name], ' > ')}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Technician(s):</b></td>
                                                    <td className='py-0'>{record_data?.member_names?.length ? helpers.concatenateText(record_data.member_names, ', ') : '---'}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='col-12'>
                                        Remarks: {record_data.remarks ? record_data.remarks : '---'}
                                    </div>
                                    {
                                        record_data?.extra_info ?
                                        <div className='col-12'>
                                            Schedule Extra Info: {record_data.extra_info ? record_data.extra_info : '---'}
                                        </div> : ''
                                    }
                                    {
                                        record_data?.assessment ?
                                        <div className='col-12'>
                                            General Asessment: {record_data.assessment ? record_data.assessment : '---'}
                                        </div> : ''
                                    }
                                    {
                                        record_data?.recommendation ?
                                        <div className='col-12'>
                                            General Recommendation: {record_data.recommendation ? record_data.recommendation : '---'}
                                        </div> : ''
                                    }
                                </div>

                                <div className='table-responsive'>
                                    <table className='table table-striped table-sm border-bottom'>
                                        <thead>
                                            <tr>
                                                <th>QR CODE</th>
                                                <th>BRAND</th>
                                                <th>SERIAL NO</th>
                                                <th>INVOICE NO</th>
                                                <th>UNIT LOCATION</th>
                                                <th>COMPLAINT</th>
                                                <th>UNIT ASSESSMENT</th>
                                                <th>UNIT RECOMMENDATION</th>
                                            </tr>
                                        </thead>
                                        {
                                            table_items
                                        }
                                    </table>
                                </div>
                            </div>
                            : 
                            <div className="invoice p-5 mb-3">
                                <h4>&nbsp;</h4>
                            </div>
                        }
                    </div>
                </div>
        </Layout>
        </>
    )
}